import { faPlus, faTicketAlt } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Flex from 'components/common/Flex';
import SoftBadge from 'components/common/SoftBadge';
import React from 'react';
import { Button, Col, Form, FormCheck, Row } from 'react-bootstrap';

const SubscriptionDefaultHeader = props => {
  return (
    <Col xs={12} className="mb-3">
      <Row className="justify-content-center justify-content-sm-between">
        <Col sm="auto" className="text-center">
          <h5 className="d-inline-block">Subscriptions plans</h5>
          <SoftBadge bg="success" className="ms-2" pill>
            Save up to 25% with a yearly plan
          </SoftBadge>
        </Col>
        <Col
          sm="auto"
          as={Flex}
          justifyContent="center"
          alignItems="center"
          className="mt-1 mt-sm-0"
        >
          <>
            {/* <FormCheck.Label htmlFor="custom-switch" className="me-2">
            Monthly
          </FormCheck.Label>
          <Form.Check type="switch" id="yearly">
            <Form.Check.Input type="checkbox" defaultChecked />
            <Form.Check.Label className="ms-2 align-top">
              Yearly
            </Form.Check.Label>
          </Form.Check> */}
            {
              <Button variant="primary" onClick={() => props.openCouponModal()}>
                <FontAwesomeIcon icon={faTicketAlt} /> I have a coupon
              </Button>
            }
          </>
        </Col>
      </Row>
    </Col>
  );
};

export default SubscriptionDefaultHeader;
